import { T_WalletProvider } from '@/ts/types/T_AuthConnectReq';

export function mapConnectorToProvider(name?: string | null): T_WalletProvider {
  if (!name) return 'METAMASK';
  const n = name.toLowerCase();
  if (n.includes('walletconnect')) return 'WALLET_CONNECT';
  if (n.includes('coinbase')) return 'COINBASE';
  if (n.includes('rabby')) return 'RABBY';
  if (n.includes('phantom')) return 'PHANTOM';
  if (n.includes('okx')) return 'OKX';
  if (n.includes('trust')) return 'TRUSTWALLET';
  if (n.includes('brave')) return 'BRAVE';
  if (n.includes('frame')) return 'FRAME';
  if (n.includes('rainbow')) return 'RAINBOW';
  if (n.includes('zerion')) return 'ZERION';
  if (n.includes('unknown')) return 'UNKNOWN';
  return 'METAMASK';
}
